(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 767px)');
  const openers = new WeakMap();
  function updateSizeSavings(root) {
    root.querySelectorAll('[data-ok-single-option="true"]').forEach(fieldset => {
      if (!fieldset.querySelector('.variant-size-savings')) return;
      let line = fieldset.nextElementSibling;
      if (!line?.matches('[data-ok-size-savings]')) {
        line = document.createElement('p');
        line.className = 'ok-mobile-only ok-size-savings';
        line.setAttribute('data-ok-size-savings', '');
        line.setAttribute('aria-live', 'polite');
        fieldset.insertAdjacentElement('afterend', line);
      }
      const checked = fieldset.querySelector('[data-variant-input]:checked');
      const label = checked?.closest('.variant-input')?.querySelector('.variant__button-label');
      const text = label?.querySelector('.variant-size-savings')?.textContent.trim() || '';
      if (line.textContent !== text) line.textContent = text;
      line.setAttribute('aria-hidden', text ? 'false' : 'true');
    });
  }
  function updateSummary(root) {
    const selected = root.querySelector('[data-product-select]')?.value;
    document.querySelectorAll('[data-ok-product-summary]').forEach(summary => {
      if (summary.dataset.productId !== root.dataset.productId) return;
      summary.querySelectorAll('[data-ok-summary-variant]').forEach(panel => {
        panel.hidden = panel.dataset.okSummaryVariant !== String(selected);
      });
    });
  }
  function updateStockPulse(root) {
    const selected = root.querySelector('[data-product-select]')?.value;
    const record = [...root.querySelectorAll('.js-variant-inventory-data')].find(el => el.dataset.id === String(selected));
    const positive = record && Number(record.dataset.quantity) > 0;
    root.querySelectorAll('[data-product-inventory]').forEach(label => {
      const row = label.closest('.icon-and-text');
      if (row) row.classList.toggle('ok-stock-positive', Boolean(positive) && !row.classList.contains('hide'));
    });
  }
  function start() {
    // Reuse explicit, populated native facts tables; never infer labels from gallery order.
    document.querySelectorAll('[data-ok-facts-fallback]').forEach(link => {
      const facts = link.closest('[data-ok-facts]');
      const owner = facts?.closest('[data-product-id]');
      // Product-level tables are safe only for a single-variant product. Exact
      // product IDs also prevent quick views from borrowing another PDP's table.
      if (!owner || facts.dataset.okProductId !== owner.dataset.productId || facts.dataset.okVariantCount !== '1') return;
      const panelId = 'Product-content-tab' + facts.dataset.okProductId;
      const matches = document.querySelectorAll('[id="' + panelId + '"]');
      if (matches.length !== 1) return;
      const panel = matches[0];
      const panelOwner = panel.closest('[data-product-id]');
      if (panelOwner && panelOwner !== owner) return;
      // A detached sibling facts section belongs to the main PDP, never a modal.
      if (!panelOwner && (!facts.dataset.okSectionId.endsWith('__main') || owner.id !== 'ProductSection-' + facts.dataset.okSectionId + '-' + facts.dataset.okProductId)) return;
      const serving = panel.querySelector('.serving-size')?.textContent.replace(/^Serving Size:\s*/i, '').trim();
      if (!serving || !panel.querySelector('table tbody tr')) return;
      const control = [...panel.parentElement.querySelectorAll('.collapsible-trigger[aria-controls]')].find(button =>
        button.getAttribute('aria-controls') === panelId && button.textContent.trim().toLowerCase() === 'supplement facts');
      if (control) {
        link.href = '#' + control.getAttribute('aria-controls');
        link.textContent = 'View Supplement Facts';
      }
    });
    document.querySelectorAll('.ok-pdp').forEach(root => {
      if (root.dataset.okPdpReady === 'true') return;
      root.dataset.okPdpReady = 'true';
      root.addEventListener('click', event => {
        const trigger = event.target.closest('[data-ok-pdp-open]');
        if (trigger && mobile.matches) {
          const dialog = document.getElementById(trigger.dataset.okPdpOpen);
          if (dialog && typeof dialog.showModal === 'function') {
            openers.set(dialog, trigger);
            dialog.showModal();
          }
        }
        const close = event.target.closest('[data-ok-pdp-close]');
        if (close) close.closest('dialog')?.close();

      });
      root.querySelectorAll('.ok-pdp-dialog').forEach(dialog => {
        dialog.addEventListener('close', () => {
          const opener = openers.get(dialog);
          if (opener?.isConnected && mobile.matches) opener.focus({preventScroll:true});
        });
      });
      root.addEventListener('change', () => queueMicrotask(() => { updateSummary(root); updateSizeSavings(root); updateStockPulse(root); }));
      root.addEventListener('variantChange', () => queueMicrotask(() => { updateSummary(root); updateSizeSavings(root); updateStockPulse(root); }));
      updateSummary(root);
      updateSizeSavings(root); updateStockPulse(root);
    });
  }
  document.addEventListener('click', event => {
        const link = event.target.closest('[data-ok-details]');
        if (!link || !mobile.matches) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        const control = target.querySelector('.collapsible-trigger') || target.closest('.collapsibles-wrapper')?.querySelector('.collapsible-trigger');
        if (control && !control.classList.contains('is-open') && control.getAttribute('aria-expanded') !== 'true') control.click();
        target.focus({preventScroll:true});
        target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  });
  mobile.addEventListener('change', () => {
    if (!mobile.matches) document.querySelectorAll('.ok-pdp-dialog[open]').forEach(dialog => dialog.close());
  });
  window.addEventListener('pageshow', () => document.querySelectorAll('.ok-pdp').forEach(root => { updateSummary(root); updateSizeSavings(root); updateStockPulse(root); }));
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

